export default "__VITE_ASSET__Dp1_ETV6__"